// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-up-wide-narrow.js';

import { paths } from '../generated/arrow-up-wide-narrow';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-up-wide-narrow', Original, paths);
